import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { ScreenplaySaveState } from "@/utils/screenplaySaveQueue";

export default function ScreenplaySaveStatus({ state, onSave, showStatus = true, showButton = true }: {
  state: ScreenplaySaveState;
  onSave: () => Promise<boolean>;
  showStatus?: boolean;
  showButton?: boolean;
}) {
  const saving = state.status === "saving";
  const failed = state.status === "error";
  const label = saving ? "Saving…" : failed
    ? "Couldn’t save. Your changes are still here. Retry before leaving."
    : state.status === "pending" ? "Unsaved changes · autosave pending"
    : state.lastSavedAt ? `Saved at ${new Date(state.lastSavedAt).toLocaleTimeString([], {
      hour: "numeric", minute: "2-digit", second: "2-digit",
    })}` : "Saved";

  return (
    <div className="flex items-center gap-3" aria-label={showStatus ? "Screenplay save controls" : "Screenplay save action"}>
      {showStatus && <span role="status" aria-live="polite" aria-atomic="true"
        className={`text-xs ${failed ? "text-destructive" : "text-muted-foreground"}`}>
        {label}
      </span>}
      {showButton && <Button size={failed ? "sm" : "icon"} variant="outline"
        className="h-9 shrink-0" onClick={() => void onSave()} disabled={saving}
        aria-label={failed ? "Retry saving screenplay" : "Save screenplay"}
        title={failed ? "Retry saving screenplay" : "Save screenplay"}>
        {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
        {failed && <span className="ml-2">Retry</span>}
      </Button>}
    </div>
  );
}
